import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import ReplayIcon from '@mui/icons-material/Replay';
import { useNavigate } from 'react-router-dom';
import { SideBarCSS } from '../styles/style';
import { PDF_TEXTS } from '../utils/texts';
import { technicalError } from 'src/common/config/TextMessage';

interface ErrorStateProps {
  onRetry: () => void;
  message?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onRetry, message }) => {
  const navigate = useNavigate();

  return (
    <Box sx={SideBarCSS.errorContainer}>
      <Typography sx={SideBarCSS.errorTitle}>
        {PDF_TEXTS.preview.error.title}
      </Typography>
      <Typography sx={SideBarCSS.errorMessage}>
        {message || technicalError}
      </Typography>
      <Box sx={SideBarCSS.errorActions}>
        <Button
          variant="contained"
          startIcon={<ReplayIcon />}
          onClick={onRetry}
          sx={SideBarCSS.errorRetryBtn}
        >
          {PDF_TEXTS.preview.error.retry}
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate('/dashboard')}
          sx={SideBarCSS.errorHomeBtn}
        >
          {PDF_TEXTS.preview.error.backToHome}
        </Button>
      </Box>
    </Box>
  );
};
